import React from "react";

interface UberOfferProps {
  logo?: string;
  name?: string;
  image?: string;
  title?: string;
  description?: string;
}

const UberOffer: React.FC<UberOfferProps> = ({
  logo = "/tesla_logoV1.png",
  name = "TESLA",
  image = "/offerImage2.png",
  title = "Complimentary Uber One for shareholders with 100+ shares",
}) => {
  return (
    <div
      className="w-full bg-[#000000] rounded-xl overflow-hidden"
      style={{
        backgroundImage: `url('${image}')`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      {/* <div className="bg-trnasparent rounded-full w-auto h-6 ml-5 mt-5 flex gap-2">
        <img src={logo} alt="Uber Logo" className="h-5 w-5 rounded-full" />
        <span className="text-white text-sm font-bold">{name}</span>
      </div> */}
      <div className="p-6 pl-5">
        {title && (
          <h2 className="text-white text-xl font-medium mb-4 max-w-64">
            {title}
          </h2>
        )}

        <button className="w-36 bg-white text-black py-3 rounded-lg font-medium text-sm hover:bg-gray-100 transition-colors">
          Learn More
        </button>
      </div>
    </div>
  );
};

export default UberOffer;

